import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Dropzone from 'react-dropzone';
import Styles from './styles';

class FileInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      files: props.value,
    };

    this.onDrop = this.onDrop.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      files: newProps.value,
    });
  }

  onDrop(acceptedFiles, rejectedFiles) {
    this.setState(
      {
        files: acceptedFiles,
      },
      () => {
        this.props.onChange(this.state.files);
      },
    );
  }

  renderPreview() {
    const imageUrl =
      this.state.files && this.state.files.length > 0
        ? this.state.files[0].preview
        : this.props.imageUrl;
    if (imageUrl) {
      const style = {
        ...Styles.preview,
        backgroundImage: `url('${imageUrl}')`,
      };
      return (
        <div style={style}>
          <div style={Styles.previewOverlay} />
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      onChange,
      style,
      value,
      error,
      showRequired,
      imageUrl,
      innerRef,
      validations,
      ...rest
    } = this.props;

    return (
      <Dropzone
        accept="image/jpeg, image/png"
        onDrop={this.onDrop}
        style={{ ...Styles.wrapper, ...this.props.style }}
        acceptStyle={Styles.activeWrapper}
        {...rest}
      >
        <div style={Styles.contents}>
          <span>{this.props.label}</span>
          {this.state.files &&
            this.state.files.length > 1 && (
              <span style={Styles.selectedFiles}>+ {this.state.files.length - 1} more</span>
            )}
          {error && showRequired && <span style={Styles.required}>required</span>}
        </div>

        {this.renderPreview()}
      </Dropzone>
    );
  }
}

FileInput.propTypes = {
  style: StylePropType,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  value: PropTypes.any,
  onChange: PropTypes.func,
  // dropzone props
  multiple: PropTypes.bool,
};

FileInput.defaultProps = {
  style: {},
  label: 'Choose a file or drag it here',
  value: [],
  onChange: () => {},
  // dropzone props
  multiple: false,
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/UIKit/FileInput/index.js